import $ from 'jquery';
import { gameCommit, gameShare } from './share';
import { generateScreenshot } from './screenshot';
import * as tips from './tips';
let hasLife = false;
const level = {
  11: '凡人期',
  30: '築基期',
  50: '結丹期',
  62: '元嬰期',
  68: '化神期',
  73: '煉虛期',
  78: '合體期',
  83: '大乘期',
  86: '渡劫期',
  87: '飛升',
};
const getLevel = year => {
  let index = 0;
  Object.keys(level).forEach(item => {
    +year > +item && index++;
  });
  index === 10 && (index = 9);
  return Object.values(level)[index];
};
const getData = data => {
  if (data.length <= 10) {
    return data;
  }
  const first = data.shift();
  const end = data.pop();
  return [first, ...randomYear(data), end];
};
const randomYear = data => {
  let newArr = [];
  const newData = data.map((item, index) => {
    return {
      text: item,
      year: index,
    };
  });
  for (let i = 0; i < 8; i++) {
    newArr.push(
      newData.splice(Math.floor(Math.random() * newData.length), 1)[0]
    );
  }
  return newArr.sort((a, b) => a.year - b.year).map(item => item.text);
};
$('.j-share').on('click', () => {
  if (!hasLife) {
    tips.alert('gameNeed');
    return;
  }
});
$('.j-life-share').on('click', async () => {
  // 生成截圖
  $('.j-screenshot-popup').fadeIn(400);
  await generateScreenshot();
  await gameShare();
});
$('.j-play-again').on('click', () => {
  $('.j-life-popup').fadeOut(400);
  $('.j-game-iframe')[0].contentWindow.location.reload();
});
window._openResPage = async function () {
  const gameIframe = $('.j-game-iframe')[0].contentWindow;
  const gameData = gameIframe.ageAndEventsData;
  const randomYear = getData(gameData);
  const achieveData = gameIframe.achieveData?.slice(0, 2);
  let yearHtml = '';
  let achievementHtml = '';
  $('.j-year-res').html(getLevel(gameData.length));
  randomYear.forEach(item => {
    yearHtml += `<p class="year">${item}</p>`;
  });
  $('.j-year-content').html(yearHtml);
  if (achieveData && achieveData.length > 0) {
    achieveData.forEach(item => {
      achievementHtml += `
               <div class="achievement">
                <p class="a-title">${item.name}</p>
                <div class="a-desc">${item.description}</div>
            </div>`;
    });
    $('.j-achievement-wrap').html(achievementHtml);
  }
  $('.j-life-popup').fadeIn(400);
  await gameCommit();
  hasLife = true;
};
